import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { IamService } from "src/app/core/apis/iam/api/api";
import { Globals } from "src/app/core/helpers/globals";

@Component({
    selector: "app-login",
    templateUrl: "./login.component.html",
    styleUrls: ["./login.component.css"],
    standalone: true,
})
export class LoginComponent implements OnInit {
  token;
  tokenIam;
  linkIdentific;
  invalidLogin: boolean;

  constructor(
    private globals: Globals,
    private iamService: IamService,
    private router: Router
  ) {}

  ngOnInit() {
    this.globals.addToLoading("login");
    this.getTokenidentifyIam();
  }

  getTokenidentifyIam() {
    this.iamService.identifyClient().subscribe(
      (response) => {
        this.tokenIam = response.body;
        sessionStorage.setItem("BearerToken", this.tokenIam.accessToken);
        this.getUrlIdentifiqIam(this.tokenIam.accessToken);
      },
      (error) => {
        this.globals.showSnackBar("Erro no processo de pré-autenticação!");
        this.router.navigate(["/error"]);
        console.error("Erro api: ", error);
      }
    );
  }

  getUrlIdentifiqIam(tokenIam) {
    this.iamService.leverageAuthStrong(tokenIam).subscribe(
      (response) => {
        this.linkIdentific = response.body;
        sessionStorage.setItem("tokenIdentifique", this.linkIdentific.token);
        window.location.href = this.linkIdentific.url;
        this.globals.subtractFromLoading();
      },
      (error) => {
        this.globals.showSnackBar(
          "Erro no processo de pré-autenticação, contate o administrador do sistema!"
        );
        console.error("Erro api: ", error);
      }
    );
  }
}
